<mat-icon (click)="closeDialog()" [style]="'margin-bottom: 2vh;'">clear</mat-icon>
<h3 id="extra-spacing">Location Overrides</h3>

<div *ngIf="loading" style="text-align: center; padding: 2rem;">
    <mat-spinner diameter="50" style="margin: 0 auto;"></mat-spinner>
    <p class="loading-text">Loading location overrides...</p>
</div>

<div *ngIf="!loading">
    <div class="mat-elevation-z2 table-container">
        <table *ngIf="formattedOverrides?.length !== 0" mat-table [dataSource]="formattedOverrides"
               aria-describedby="unpublished changes">

            <ng-container matColumnDef="key">
                <th mat-header-cell *matHeaderCellDef class="text-wrapper text-center"><strong>Location</strong></th>
                <td mat-cell *matCellDef="let row" class="text-wrappe text-center">{{ row.key }}</td>
            </ng-container>

            <ng-container matColumnDef="value">
                <th mat-header-cell *matHeaderCellDef class="text-wrapper text-center"><strong>Override Value</strong></th>
                <td mat-cell *matCellDef="let row" class="text-wrapper text-center">{{ row.value }}</td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
    </div>
    <div *ngIf="formattedOverrides?.length === 0 || !formattedOverrides" style="text-align: center">
        There are no overrides for {{ this.data.attribute.name }}
    </div>
</div>
